<template>
    <recaptcha-form
        v-model="form.recaptcha"
        @submit="$emit('submit', form)"
    >
        <div class="px-6 pt-6 border-b">
            <h6 class="mb-3 text-lg font-normal font-semibold text-center">
                <slot name="heading">
                    Create an account
                </slot>
            </h6>

            <slot name="intro" />

            <validator-alert :sid="sid" />

            <form-item
                :sid="sid"
                :is-required="true"
                name="persona"
                v-if="!isTenant"
            >
                <template slot="label">Profile</template>

                <input-select
                    v-model="form.persona"
                    :sid="sid"
                    :disabled="is_saving"
                    :options="[
                        { value: 'landlord', label: 'I\'m a Landlord / Agent' },
                        { value: 'tenant', label: 'I\'m a Tenant' }
                    ]"
                    name="term"
                />
            </form-item>

            <form-item
                :sid="sid"
                :is-required="true"
                name="first_name"
            >
                <template slot="label">First Name</template>

                <input-text
                    v-model="form.first_name"
                    :sid="sid"
                    :disabled="is_saving"
                    name="first_name"
                />
            </form-item>

            <form-item
                :sid="sid"
                :is-required="true"
                name="last_name"
            >
                <template slot="label">Last Name</template>

                <input-text
                    v-model="form.last_name"
                    :sid="sid"
                    :disabled="is_saving"
                    name="last_name"
                />
            </form-item>

            <form-item
                :sid="sid"
                :is-required="true"
                name="email"
            >
                <template slot="label">Email</template>

                <input-text
                    v-model="form.email"
                    :sid="sid"
                    :disabled="is_saving"
                    name="email"
                    type="email"
                />
            </form-item>

            <form-item
                :sid="sid"
                :is-required="true"
                name="telephone"
            >
                <template slot="label">Telephone</template>

                <input-telephone
                    v-model="form.telephone"
                    :sid="sid"
                    :disabled="is_saving"
                    placeholder="7000 000 000"
                    name="telephone"
                />
            </form-item>

            <form-item
                :sid="sid"
                :is-required="true"
                name="password"
            >
                <template slot="label">Password</template>

                <input-text
                    v-model="form.password"
                    :sid="sid"
                    :disabled="is_saving"
                    name="password"
                    type="password"
                />
            </form-item>

            <button
                v-if="!show_referral_code_input"
                type="button"
                class="flex items-center justify-center w-full mb-3 -mt-3 text-xs text-center text-blue focus:outline-none"
                @click.prevent="show_referral_code_input = true"
            >
                <div>Got a referral code?</div>

                <base-svg
                    name="icon-cheveron-down"
                    class="w-4 h-4 ml-1 fill-primary-blue"
                />
            </button>

            <form-item
                v-else
                :sid="sid"
                name="referral_code"
            >
                <template slot="label">Referral code</template>

                <input-text
                    v-model="form.referral_code"
                    :sid="sid"
                    :disabled="is_saving"
                    name="referral_code"
                    type="text"
                />
            </form-item>
        </div>

        <div class="px-6 py-3 text-right rounded-b bg-grey-bg">
            <base-button
                :is-loading="is_saving"
                class="w-full btn-blue"
            >
                Create Account
            </base-button>

            <div class="pt-3 text-xs leading-tight text-center text-grey-darker">
                By registering your account, you agree to our
                <laroute-link
                    :to="{ name: 'www.policies.terms.index' }"
                    class="text-blue"
                >
                    Terms,
                </laroute-link>

                <laroute-link
                    :to="{ name: 'www.policies.privacy.index' }"
                    class="text-blue"
                >
                    Privacy
                </laroute-link>

                &amp;

                <laroute-link
                    :to="{ name: 'www.policies.cookies.index' }"
                    class="text-blue"
                >
                    Cookie
                </laroute-link>

                policies.

                This site is protected by reCAPTCHA and the Google
                <a
                    href="https://policies.google.com/privacy"
                    class="text-blue"
                >
                    Privacy Policy
                </a>
                and
                <a
                    href="https://policies.google.com/terms"
                    class="no-underline text-blue"
                >
                    Terms of Service
                </a>
                apply.
            </div>
        </div>

        <slot name="modals" />
    </recaptcha-form>
</template>

<script>
    import local from '../store/local'
    import RecaptchaForm from './recaptcha-form'

    export default {
        components: {
            RecaptchaForm
        },
        props: {
            sid: {
                type: String,
                required: true
            },
            isSaving: {
                type: Boolean,
                required: true
            },
            persona: {
                type: String,
                default: 'landlord'
            },
            isTenant: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                show_referral_code_input: !!this.$route.query.referral_code,
                form: {
                    recaptcha: '',
                    persona: this.persona,
                    first_name: '',
                    last_name: '',
                    email: '',
                    telephone: null,
                    password: '',
                    referral_code: this.$route.query.referral_code
                }
            }
        },
        computed: {
            is_saving () {
                return this.isSaving
            }
        },
        watch: {
            'form.email' () {
                local.set('guest-email', this.form.email)
            }
        },
        created () {
            if (!this.form.email) {
                this.form.email = local.get('guest-email')
            }

            if (this.isTenant) {
                this.form.persona = 'tenant'
            }
        }
    }
</script>
